import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/site";
import { Hero } from "@/components/site/Hero";
import { Marquee, Stats } from "@/components/site/Marquee";
import { Consultations, Pillars, Yagya } from "@/components/site/Services";
import { Dosh } from "@/components/site/Dosh";
import { Rashifal } from "@/components/site/Rashifal";
import { About, Process } from "@/components/site/About";
import { Contact, Faq } from "@/components/site/Contact";
import { Stories, Tools } from "@/components/site/Extras";
import { TodayPanchang } from "@/components/site/TodayPanchang";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const id = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(id);
  }, [hash]);
  return (
    <>
      <Hero />
      <TodayPanchang />
      <Marquee />
      <Stats />
      <Pillars />
      <Tools />
      <Consultations />
      <Yagya />
      <Dosh />
      <Rashifal />
      <About />
      <Stories />
      <Process />
      <Faq />
      <Contact />
    </>
  );
}
